import { render, staticRenderFns } from "./LocationAssetDetails.vue?vue&type=template&id=181ff92a"
import script from "./LocationAssetDetails.vue?vue&type=script&lang=js"
export * from "./LocationAssetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports